module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Bloom-menu', {
    staticClass: "menu-center-wrapper",
    attrs: {
      "iconImgArr": _vm.iconImgArr,
      "radius": 100
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/vue-loader/10.3.0/vue-loader/lib/template-compiler.js?id=data-v-76af07c1!./~/.npminstall/vue-loader/10.3.0/vue-loader/lib/selector.js?type=template&index=0!./src/Center.vue
// module id = 31
// module chunks = 1